/**
 * PPATCH - Pré-remplissage formulaire de contact
 * Pré-remplit automatiquement le formulaire de contact depuis les paramètres URL
 */

document.addEventListener('DOMContentLoaded', function() {
  // Récupérer les paramètres URL
  const params = new URLSearchParams(window.location.search);
  const subject = params.get('subject');
  const product = params.get('product');
  const url = params.get('url');
  
  // Si aucun paramètre, pas de pré-remplissage
  if (!subject) return;
  
  // Pré-remplir le champ sujet (si le champ existe)
  const subjectField = document.querySelector('input[name="contact[subject]"], select[name="contact[subject]"]');
  if (subjectField) {
    subjectField.value = decodeURIComponent(subject);
  }
  
  // Pré-remplir le message pour les demandes de suppression
  if (subject === 'Suppression' && product && url) {
    const messageField = document.querySelector('textarea[name="contact[body]"]');
    if (messageField) {
      const message = `Je souhaite demander la suppression du produit suivant :\n\nNom : ${decodeURIComponent(product)}\nURL : ${decodeURIComponent(url)}\n\nRaison de ma demande :\n`;
      messageField.value = message;
      
      // Optionnel : Focus sur le textarea pour que l'utilisateur voit directement
      messageField.focus();
      // Placer le curseur à la fin du texte pré-rempli
      messageField.setSelectionRange(message.length, message.length);
    }
  }
});